import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

import utils from '../../lib/utils';

export default function VoicemailRow({ voicemail, onPlay, onReadToggle }) {
  const onPlayClick = () => {
    onPlay(voicemail);
  };

  const onCheck = (event) => {
    onReadToggle(voicemail, !!event.target.checked);
  };

  const getUrl = (link) => {
    let isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox && !link.includes('.mp3')) {
      return link + '.mp3';
    } else {
      return link;
    }
  };

  const isComplete = voicemail.isHandled || voicemail.isRead;

  return (
    <tr className={classnames({ unread: !isComplete })}>
      <td>
        <input
          type="checkbox"
          checked={isComplete}
          onChange={onCheck}
        />
      </td>
      <td>
        {moment.parseZone(voicemail.ISO_DATE).format('Do MMM, YYYY HH:mm')}
      </td>
      <td>{voicemail.duration}</td>
      <td>{voicemail.forwardedFrom}</td>
      <td>{voicemail.callerName}</td>
      <td>
        {
          utils.hyphenatePhone(voicemail.callerNumber)
        }
      </td>
      <td>
        <a
          href={getUrl(voicemail.url)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onPlayClick}
        >
          <i className="material-icons">play_arrow</i>
        </a>
      </td>
    </tr>
  );
}

VoicemailRow.defaultProps = {
  onPlay: () => { },
  onReadToggle: () => { },
  voicemail: {
    callerName: '',
    callerNumber: '',
    duration: 0,
    timestamp: null,
    url: '',
  },
};

VoicemailRow.propTypes = {
  onPlay: PropTypes.func,
  onReadToggle: PropTypes.func,
  voicemail: PropTypes.shape({
    callerName: PropTypes.string,
    callerNumber: PropTypes.string,
    duration: PropTypes.number,
    timestamp: PropTypes.number,
    url: PropTypes.string,
  }),
};
